module.exports = __webpack_public_path__ + "img/HOLDEN.5a0337e.jpg";